export default __webpack_public_path__ + "static/media/slide1.2.1b9b0927.jpg";